import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import App from "@/views/App.vue";
import SLO from "@/views/SLO.vue";
import AuthCallback from "@/views/AuthCallback.vue";

Vue.use(Router);

function checkAuth(to, from, next) {
  if (process.env.VUE_APP_DEMO) {
    next();
    return
  }
  if (Vue.prototype.$auth0.isAuthenticated()) {
    next();
    return
  }
  Vue.prototype.$auth0.login();
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      beforeEnter: checkAuth
    },
    {
      path: "/authcallback",
      name: "AuthCallback",
      component: AuthCallback
    },
    {
      path: "/app",
      name: "app",
      component: App,
      beforeEnter: checkAuth,
      props: (route)=> ({name: route.query.name})
    },
    {
      path: "/slo",
      name: "SLO",
      component: SLO,
      beforeEnter: checkAuth,
      props(route) {
        const query = {...route.query};
        query.id = Number(query.id);
        return query;
      }
    },
    {
      path: "/about",
      name: "about",
      beforeEnter: checkAuth,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    }
  ]
});
